import { Box, Stack, Typography } from "@mui/material";
import { taskTimelineStatus } from "@/features/chat/phase1/workStatusThoughts";
import StepIcon from "./StepIcon";
import TaskNarration from "./TaskNarration";

function readableStatus(status) {
  return String(status ?? "unknown").replaceAll("_", " ");
}

export default function TaskHeading({ task, streaming = false }) {
  const status = taskTimelineStatus(task.status);
  return (
    <Stack direction="row" sx={{ gap: 1, alignItems: "flex-start" }}>
      <Box
        sx={{ width: 14, display: "flex", justifyContent: "center", pt: "2px" }}
      >
        <StepIcon status={status} streaming={streaming} />
      </Box>
      <Stack sx={{ gap: 0.2, minWidth: 0, flex: 1 }}>
        <Stack
          direction="row"
          sx={{
            alignItems: "baseline",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography sx={{ fontSize: 15, color: "var(--app-text-primary)" }}>
            {task.title}
          </Typography>
          <Typography
            sx={{
              fontSize: 13,
              color: "var(--app-text-secondary)",
              textTransform: "capitalize",
              whiteSpace: "nowrap",
            }}
          >
            {readableStatus(task.status)}
          </Typography>
        </Stack>
        <TaskNarration task={task} />
      </Stack>
    </Stack>
  );
}
